import { makeAutoObservable, runInAction } from "mobx";
import api from "../Utils/api";
import packageJson from "../../package.json";

class AdminStore {
  appUpdates = [];
  appUpdatesLoaded = false;
  appUpdateUpload = false;

  users = [];
  usersLoaded = false;

  serverVersion = null;
  clientVersion = null;
  versionsLoaded = false;

  constructor() {
    makeAutoObservable(this);
  }

  loadUsers() {
    api.getUsers().then((resp) => {
      runInAction(() => {
        this.usersLoaded = true;
        this.users = resp.users;
      });
    });
  }

  previewUserMerge(sourceUserId, targetUserId) {
    return api.previewUserMerge(sourceUserId, targetUserId);
  }

  mergeUsers(sourceUserId, targetUserId) {
    return api.mergeUsers(sourceUserId, targetUserId).then((result) => {
      runInAction(() => {
        this.users = this.users.filter(u => u.id !== sourceUserId);
      });
      return result;
    });
  }

  loadAppUpdates() {
    api.getAppInfo().then((appInfo) => {
      runInAction(() => {
        this.appUpdates = appInfo.all;
        this.appUpdatesLoaded = true;
      });
    });
  }

  pushAppUpdate(updateFile, changeLog) {
    this.appUpdateUpload = true;
    api
      .pushAppUpdate(updateFile, changeLog)
      .then((update) => {
        runInAction(() => {
          this.appUpdates.push(update);
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.appUpdateUpload = false;
      });
  }

  pushNotification(to, title, body) {
    api.pushAdminNotification(to, title, body).then((res) => {
      console.log(res);
    });
  }

  loadVersions() {
    api.getServerVersion()
      .then((serverResp) => {
        runInAction(() => {
          this.serverVersion = serverResp.version;
          this.clientVersion = packageJson.version;
          this.versionsLoaded = true;
        });
      })
      .catch((err) => {
        console.error('Error loading versions:', err);
        runInAction(() => {
          this.versionsLoaded = true;
        });
      });
  }
}

const adminStore = new AdminStore();
export default adminStore;
